// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reviews_main_contnet_Ud8j-{clear:both;margin:0}@media only screen and (min-width:768px){.reviews_main_contnet_Ud8j-{padding:2.5rem 0 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reviews_main_contnet": "reviews_main_contnet_Ud8j-"
};
module.exports = ___CSS_LOADER_EXPORT___;
